import { render } from "./CustomPosition.vue?vue&type=template&id=6d7599ba"
import script from "./CustomPosition.vue?vue&type=script&lang=js"
export * from "./CustomPosition.vue?vue&type=script&lang=js"
script.render = render

export default script